import React from "react";
import banner from "../../assets/images/law.jpg";
import "./Banner.css";

const Banner = () => {
  return (
    <div>
      <div className="w-full banner"></div>
    </div>
  );
};

export default Banner;
